import { Outlet } from '@tanstack/react-router'
import { Space, Typography } from 'antd'
import { RiMoonClearLine, RiSparkling2Line } from 'react-icons/ri'

import { useTheme } from '@/core/hooks/use-theme'

// Giriş/auth rotaları için ortalanmış kabuk. Dashboard ile birebir tasarım:
// gradient orb arka planı + tema değiştirme düğmesi. Motion'suz (Tailwind
// transition); tema geçişi store'daki native View Transitions API ile animasyonlu.
const AuthLayout = () => {
  const { theme, toggleTheme } = useTheme()
  const isCanli = theme === 'canli'

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-linear-to-br from-indigo-500/10 to-purple-600/10 p-6">
      <div className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-linear-to-br from-indigo-500/10 to-purple-600/10" />
      <div className="absolute -bottom-36 -left-36 h-96 w-96 rounded-full bg-linear-to-br from-indigo-500/10 to-purple-600/10" />

      <button
        type="button"
        onClick={(event) =>
          toggleTheme({ clientX: event.clientX, clientY: event.clientY })
        }
        data-testid="theme-toggle"
        aria-label="Tema değiştir"
        className={
          isCanli
            ? 'fixed top-4 right-4 z-10 inline-flex h-10 cursor-pointer items-center gap-2 overflow-hidden rounded-full border border-[var(--app-border)] bg-gradient-to-r from-[#7c5cff] via-[#22d3ee] to-[#ec4899] px-4 text-xs font-semibold text-white shadow-[0_8px_24px_-8px_rgba(124,92,255,0.7)] transition-transform duration-200 hover:scale-105 active:scale-90 sm:top-6 sm:right-6'
            : 'fixed top-4 right-4 z-10 inline-flex h-10 cursor-pointer items-center gap-2 rounded-full border border-gray-200 bg-white px-4 text-xs font-semibold text-gray-700 shadow-lg transition-transform duration-200 hover:scale-105 hover:bg-gray-50 active:scale-90 sm:top-6 sm:right-6'
        }
      >
        <span className="inline-flex items-center gap-2">
          {isCanli ? (
            <>
              <RiSparkling2Line className="h-4 w-4" />
              Canlı
            </>
          ) : (
            <>
              <RiMoonClearLine className="h-4 w-4" />
              Klasik
            </>
          )}
        </span>
      </button>

      <div className="relative w-full max-w-lg rounded-2xl border-0 bg-white p-4 shadow-lg sm:p-8 sm:shadow-2xl">
        <Space orientation="vertical" size={24} className="w-full">
          <Space
            orientation="vertical"
            size={4}
            align="center"
            className="w-full"
          >
            <div className="flex justify-center">
              <div
                className="flex h-24 w-full max-w-xs items-center justify-center rounded-2xl bg-[linear-gradient(135deg,#3a306f_0%,#2a2a5e_55%,#1f1f4d_100%)] px-8 shadow-[0_12px_32px_-12px_rgba(20,16,60,0.55)]"
                data-testid="auth-logo-frame"
              >
                <img src="/logo.png" alt="Bilgilig" className="h-12 w-auto" />
              </div>
            </div>
            <Typography.Text className="text-center text-2xl! font-semibold">
              Bilgilig'e Hoş Geldiniz
            </Typography.Text>
            <Typography.Text type="secondary" className="text-center">
              Yönetim paneline giriş yapın
            </Typography.Text>
          </Space>

          <Outlet />

          <Space
            orientation="vertical"
            size={4}
            align="center"
            className="w-full border-t border-gray-100 pt-5 text-center"
          >
            <Typography.Text type="secondary" className="text-xs">
              © {new Date().getFullYear()} Bilgilig. Tüm hakları saklıdır.
            </Typography.Text>
          </Space>
        </Space>
      </div>
    </div>
  )
}

export default AuthLayout
